import AdminList from '@components/admin/AdminList'

const DataAdminRoute = () => {
  return (
    <div>
      <div className="bg-white rounded-xl p-4">
        <h1 className="text-center text-xl md:text-2xl lg:text-4xl font-semibold">Data Admin</h1>
      </div>

      <div>
        <AdminList />
      </div>
    </div>
  )
}

export default DataAdminRoute